<template>
  <div class="account">
    <div class="search">
      <search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :width="listTypeInfo.width"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
      />
    </div>
    <div class="table">
      <div class="handle-btn">
        <div>对账单列表</div>
        <div class="right">
          <div class="search-total">查询到{{ total }}条对账单</div>
          <el-button @click="exportDetail" :disabled="tableData.length === 0">
            导出对账单明细
          </el-button>
        </div>
      </div>
      <table-list :table-data="tableData" :table-label="tableLabel" :loading="loading">
        <template #reconciliationStatus="{scope}">
          <span>{{ getReconciliationStatus(scope.row.reconciliationStatus) }}</span>
        </template>
        <template #handle="{scope}">
          <span class="text-btn" @click="goUrl(scope.row, 'detail')">查看详情</span>
          <span
            class="text-btn"
            @click="goUrl(scope.row)"
            v-if="scope.row.reconciliationStatus === 1"
          >
            确认
          </span>
        </template>
      </table-list>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin.js';
import api from '@/modules/projectA/api/order/index';
import utils from '@/modules/projectA/utils/utils';
import _ from 'lodash';
export default {
  mixins: [mixin],
  data() {
    return {
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        reconciliationNo: '',
        orderNo: '',
        supplierCompanyName: '',
        reconciliationStatus: '',
        time: null,
        startTime: '',
        endTime: '',
      },
      fieldList: [
        {
          label: '对账单号',
          type: 'input',
          value: 'reconciliationNo',
          placeholder: '支持模糊搜索',
        },
        /* { label: "订单号", type: "input", value: "orderNo", placeholder: "支持模糊搜索" }, */
        {
          label: '对账单名称',
          type: 'input',
          value: 'reconciliationName',
          placeholder: '支持模糊搜索',
        },
        {
          label: '对账接收方',
          type: 'input',
          value: 'supplierCompanyName',
          placeholder: '支持模糊搜索',
        },
        {
          label: '对账状态',
          type: 'select',
          value: 'reconciliationStatus',
          placeholder: '请选择',
          list: 'reconciliationStatusList',
        },
        {
          label: '对账时间',
          type: 'date',
          value: 'time',
          dateType: 'daterange',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      listTypeInfo: {
        // 对账单状态 1:待供应商确认 2: 对账完成 3: 已撤回
        reconciliationStatusList: [
          {
            id: '',
            name: '全部',
          },
          {
            id: 1,
            name: '待确认',
          },
          {
            id: 2,
            name: '已确认',
          },
          {
            id: 3,
            name: '已拒绝',
          },
        ],
        width: {
          labelWidth: 120,
          itemWidth: 200,
        },
      },

      tableData: [],
      total: 0,
      tableLabel: [
        {
          label: '对账单号',
          param: 'reconciliationNo',
          align: 'center',
          width: '180',
          fixed: 'left',
        },
        {
          label: '对账单名称',
          param: 'reconciliationName',
          align: 'center',
          width: '180',
        },
        {
          label: '对账发起方',
          param: 'purchaseCompanyName',
          align: 'center',
          width: '180',
        },
        {
          label: '对账接收方',
          param: 'supplierCompanyName',
          align: 'center',
          width: '180',
        },
        {
          label: '对账金额(元)',
          param: 'amount',
          align: 'center',
          width: '180',
         },
        {
          label: '对账状态',
          param: 'reconciliationStatus',
          align: 'center',
          slot: 'reconciliationStatus',
        },
        {
          label: '对账时间',
          param: 'reconciliationDate',
          align: 'center',
          width: '180',
        },

        {
          label: '联系人',
          param: 'applyRealName',
          align: 'center',
         },
        {
          label: '联系电话',
          param: 'applyTelephone',
          align: 'center',
          width: '180',
        },
        {
          label: '邮箱',
          param: 'applyMail',
          align: 'center',
          width: '180',
        },
        {
          label: '操作',
          param: 'businessFlowNo',
          align: 'center',
          width: '180',
          slot: 'handle',
          fixed: 'right',
        },
      ],
      loading: false,
    };
  },
  computed: {},
  mounted() {
    this.getList(this.listQuery);
  },
  methods: {
    async getList(params) {
      const result = await api.reconciliationPage(params);
      console.log();
      if (result.code === '200') {
        const data = result.data;
        this.tableData = [...data.records];
        this.total = data.total;
      }
    },
    getReconciliationStatus(status) {
      const { name } =
        this.listTypeInfo.reconciliationStatusList.find(item => item.id === status) || {};
      return name;
    },
    handleClear() {
      this.listQuery = { ...this.$options.data().listQuery };
      this.getList(this.listQuery);
    },
    handleSearch(val) {
      this.listQuery = { ...val };
      if (val?.time?.length) {
        this.listQuery.startTime = val.time[0];
        this.listQuery.endTime = val.time[1];
      } else {
        this.listQuery.startTime = '';
        this.listQuery.endTime = '';
      }
      this.listQuery.statusList = this.listQuery.reconciliationStatus
        ? [this.listQuery.reconciliationStatus]
        : '';
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.listQuery.pageNum = 1;
      this.listQuery.statusList = this.listQuery.reconciliationStatus
        ? [this.listQuery.reconciliationStatus]
        : '';
      this.getList(this.listQuery);
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.listQuery.statusList = this.listQuery.reconciliationStatus
        ? [this.listQuery.reconciliationStatus]
        : '';
      this.getList(this.listQuery);
    },
    goUrl(row, type) {
      const { purchaseCompanyId, reconciliationId } = row;
      console.log(purchaseCompanyId, 'purchaseCompanyId');
      this.$router.push({
        path: '/accountDetail',
        query: {
          purchaseCompanyId,
          reconciliationId,
          type,
        },
      });
    },

    exportDetail: _.debounce(async function() {
      const result = await api.exportReconciliation(this.listQuery);
      if (result?.code === '500') {
        return;
      }
      if (result.type == 'application/json') {
        utils.fileExportResponseError(result);
      } else {
        const time = utils.formatDate(new Date(), 'yyyyMMdd');
        utils.downFile(result, `对账单信息_${time}`);
      }
    }),
  },
};
</script>
<style lang="scss" scoped>
.text-btn {
  font-size: 14px;
  font-weight: 350;
  color: #0064c8;
  margin-left: 20px;
  cursor: pointer;
  font-size: 12px;
  &:hover {
    text-decoration: underline;
  }
}
.account {
  .search {
    padding: 10px 0;
    background: #fff;
    ::v-deep .search-content {
      .item-style {
        margin: 0;
        margin-bottom: 10px;
      }
    }
  }
  .table {
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    ::v-deep .el-table {
      th.el-table__cell > .cell {
        font-weight: normal;
        font-size: 14px;
      }
    }
  }
  .handle-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    .right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .search-total {
        margin-right: 10px;
        color: #999;
      }
      ::v-deep .el-button {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
  .pagination-box {
    text-align: right;
    margin-top: 20px;
    margin-bottom: 0;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
        }
        .active {
          background: #2587ff;
          border: none;
          color: #fff;
        }
      }
    }
  }
}
</style>
